import ControlQualityPage from "./ControlQuality"
import IpStocks41Page from "./IpStocks41"
import MarketReportItemsAllPage from "./MarketReportItemsAll"
import MarketReportsPage from "./MarketReports"
import MarketReportPage from "./MarketReports/MarketReport"
import NomenclaturePage from "./Nomenclature"
import RealizationsPage from "./Realizations"
import RealizationPage from "./Realizations/Realization"
import ReturnsReportsPage from "./ReturnsReports"
import ReturnsReportPage from "./ReturnsReports/ReturnsReport"

const ReportsPages = {
    IpStocks41: IpStocks41Page,
    Nomenclature: NomenclaturePage,
    ControlQuality: ControlQualityPage, 

    MarketReports: MarketReportsPage,
    MarketReport: MarketReportPage,
    MarketReportItemsAll: MarketReportItemsAllPage,

    Realizations: RealizationsPage,
    Realization: RealizationPage,

    ReturnsReportsPage,
    ReturnsReportPage,
}

export default ReportsPages